import useTranslation from 'next-translate/useTranslation'

import RichTextTrimmer from '@/molecules/RichTextTrimmer'

function ExperienceInstructions({ instructions, termsHref }: DescriptionProps) {
  const { t } = useTranslation('products')

  return instructions ? (
    <>
      <div className="mt-6 2md:mt-8">
        <h2 className="mb-3 text-xl font-medium md:text-2xl">
          {t('contest_instructions')}
        </h2>
        <div className="space-y-8">
          <RichTextTrimmer value={instructions} />
        </div>
      </div>
      {termsHref && (
        <a
          className="inline-block mt-6 font-medium text-center xl:text-left text-sbtviolet-600 hover:underline hover:text-sbtviolet-700"
          href={termsHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('download_terms')}
        </a>
      )}
    </>
  ) : (
    <></>
  )
}

interface DescriptionProps {
  instructions: string | undefined
  termsHref: string | undefined
}

export default ExperienceInstructions
